import { useMemo } from 'react'

import { GetEntityLayersQuery, GetEntityLayersQueryVariables } from '../../types/graphql'
import { QueryKey, useQuery } from '../utils/queryClient'

const GetEntityLayers = gql`
  query GetEntityLayersQuery($entityLayerIds: [Int!]!) {
    getEntityLayersByIds(entityLayerIds: $entityLayerIds) {
      ...EntityLayerFragment
    }
  }
`

export const useGetEntityLayersQuery = (entityLayerIds: number[]) => {
  const { data, ...rest } = useQuery<GetEntityLayersQuery, GetEntityLayersQueryVariables>({
    queryKey: [QueryKey.GetEntityLayers, entityLayerIds],
    queryDocument: GetEntityLayers,
    variables: { entityLayerIds },
    enabled: !!entityLayerIds.length,
  })
  const entityLayers = useMemo(() => data?.getEntityLayersByIds ?? [], [data])
  return {
    entityLayers,
    ...rest,
  }
}
